/**
 * @description Notifications component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/Notifications
 */

import React from 'react';
import PropTypes from 'prop-types';

import Notification from './Notification';

/**
 * @description The Notifications component.
 * @class 
 * @extends {React.Component}
 */
class Notifications extends React.Component {

    /**
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            fadeIn: false,
            isVisible: false
        };
    }

    /**
     * @inheritdoc
     */
    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.notifications !== nextProps.notifications ||
            this.state.fadeIn !== nextState.fadeIn ||
            this.state.isVisible !== nextState.isVisible
        );
    }

    /**
     * @inheritdoc
     */
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.notifications.length !==
                this.props.notifications.length &&
            prevProps.notifications.length === 0
        ) {
            clearTimeout(this.fadeTimeout);
            this.setState({
                isVisible: true
            });
            // Timeout needed to allow for render before fade in.
            setTimeout(() =>
                this.setState({
                    fadeIn: true
                }), 0
            );
        } else if (prevState.fadeIn === true && this.state.fadeIn === false) {    
            // Timeout needed to allow for fade out before hiding notifications.
            this.fadeTimeout = setTimeout(() =>
                this.setState({
                    isVisible: false
                }), 200
            );
        } else if (this.props.notifications.length === 0) {
            this.setState({
                fadeIn: false
            });
        }
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        clearTimeout(this.fadeTimeout);
    }

    /**
     * @inheritdoc
     */
    render() {
        const className = `Notifications${this.state.fadeIn ? ' active' : ''}`;

        return (
            this.state.isVisible && (
                <div className={className}>
                    {this.props.notifications.map(notification => (
                        <Notification
                            key={notification.id}
                            notification={notification}
                            onCloseNotification={this.props.onCloseNotification}
                            onClickNotificationAction={
                                this.props.onClickNotificationAction
                            }></Notification>
                    ))}
                </div>
            )
        );
    }
}

Notifications.defaultProps = {
    notifications: [],
    onCloseNotification: () => null,
    onClickNotificationAction: () => null
};

Notifications.propTypes = {
    notifications: PropTypes.array.isRequired,
    onCloseNotification: PropTypes.func.isRequired,
    onClickNotificationAction: PropTypes.func.isRequired
};

export default Notifications;
